import styled from 'styled-components';

export const StyledCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  box-shadow: 0px 4px 1rem rgba(0, 0, 0, 0.04);
  overflow: hidden;
`;

export const StyledHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray6};
`;

export const StyledBody = styled.div`
  padding: 1.5rem;
`;

export const PreviewContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.gray6};
  border-radius: 4px;
  padding: 1rem;
  min-height: 200px;
  background: white;
`;
